import { useEffect, useState } from "react";
import { AppWindow } from "lucide-react";

/** Turn a stored logo address into a same-origin image URL. */
export function logoSrc(value: unknown): string {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  if (raw.startsWith("/assets/logos/") || raw.startsWith("/assets/avatars/")) return `/bff${raw}`;
  if (raw.startsWith("https://") || raw.startsWith("http://")) return raw;
  return "";
}

export type LogoStage = "primary" | "fallback" | "dead";

/** Pick the first address that can be requested. */
export function initialLogoStage(primary: string, fallback: string): LogoStage {
  if (primary) return "primary";
  if (fallback) return "fallback";
  return "dead";
}

/** Move to the other logo after the current image fails, once. */
export function nextLogoStage(stage: LogoStage, primary: string, fallback: string): LogoStage {
  if (stage === "primary" && fallback && fallback !== primary) return "fallback";
  return "dead";
}

export function AppLogo({ url, fallbackUrl, className = "app-logo" }: { url?: unknown; fallbackUrl?: unknown; className?: string }) {
  const primary = logoSrc(url);
  const fallback = logoSrc(fallbackUrl);
  const [stage, setStage] = useState<LogoStage>(() => initialLogoStage(primary, fallback));
  useEffect(() => {
    setStage(initialLogoStage(primary, fallback));
  }, [primary, fallback]);
  const src = stage === "primary" ? primary : stage === "fallback" ? fallback : "";
  if (!src || stage === "dead") return <AppWindow aria-hidden="true" />;
  return <img className={className} src={src} alt="" onError={() => setStage((current) => nextLogoStage(current, primary, fallback))} />;
}
